// extracted by mini-css-extract-plugin
module.exports = {"button":"ScommesseTableStatsTrigger_button__8_c8B","icon":"ScommesseTableStatsTrigger_icon__z_oTW","skeleton":"ScommesseTableStatsTrigger_skeleton__TPft3"};